import { CSSObject } from '@chakra-ui/react';

export const GridItemResponsibleGambling: CSSObject = {
  position: 'relative',
};
